import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../../Utils/UtilsPricesFormat';
import { orderPaymentLinkTrace, orderPromoTrace } from './orderDisplay';

/**
 * Montant payé. Promo : tarif réel barré. Lien direct : accès à la fiche du lien.
 */
export default function OrderPaidPrice({ order, className = '' }) {
    const paid = order?.total_price;
    if (paid == null || paid === '') {
        return <>...</>;
    }

    const { hasPromo, originalTotal } = orderPromoTrace(order);
    const { isPaymentLink, linkId } = orderPaymentLinkTrace(order);

    return (
        <div className={`c2hoo ${className}`.trim()}>
            <div className="flex items-center gap-1">
                <div className="cdjj4 c1k3n font-semibold">{formatPrice(paid)}</div>
                {isPaymentLink && (
                    <i
                        className="las la-link text-sm cdjj4 font-semibold dark:text-gray-100"
                        title="Lien direct"
                        aria-label="Lien direct"
                    />
                )}
            </div>
            {hasPromo && originalTotal != null && (
                <div className="mt-0.5 inline-flex gap-1 items-center">
                    <div className="text-xs text-gray-400 line-through decoration-gray-400">
                        {formatPrice(originalTotal)}
                    </div>
                    <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-400 mr-1">
                        Promo
                    </div>
                </div>
            )}
            {isPaymentLink && linkId ? (
                <Link
                    to={`/dashboard/communiquer/liens-paiement/${encodeURIComponent(linkId)}`}
                    className="mt-0.5 inline-block text-[11px] font-medium text-blue-600 hover:text-blue-700 hover:underline"
                >
                    Voir le lien
                </Link>
            ) : null}
        </div>
    );
}
